import classNames from 'classnames';
import { ProductFactsheetLink } from 'components/product-factsheet-link';
import { ProductVideoButton } from 'components/product-video-button';
import { useTranslateProductName } from 'hooks/use-translate-payoff';
import { ProductVariationBase } from 'models/productsReferential';
import { ComponentProps } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSmartQuoteProductsQuery } from 'routes/smart-quote/hooks/use-products-query';

export function SupportProductList({ className, ...rest }: Omit<ComponentProps<'ul'>, 'children'>) {
  const { products, isLoading } = useSmartQuoteProductsQuery();

  if (isLoading) {
    return <Skeleton count={5} />;
  }

  return (
    <ul
      aria-label="smart quote available products"
      className={classNames('list-group-item border-bottom border-opacity-40', className)}
      {...rest}
    >
      {products.map(product => (
        <ProductItem key={`${product.productType}-${product.productSubType}`} product={product} />
      ))}
    </ul>
  );
}

function ProductItem({ product }: { product: Readonly<ProductVariationBase> }) {
  const { productName, productTypeLabel, productSubtypeLabel } = useTranslateProductName(
    product.productType,
    product.productSubType,
  );

  return (
    <li
      className="list-group-item flex-x border-top border-opacity-40"
      style={{ height: '40px' }}
      aria-label={productName}
    >
      <div className="flex-grow-1 text-start text-truncate">
        <span className="text-secondary">{productTypeLabel}</span>
        <span className="text-secondary"> / </span>
        <span>{productSubtypeLabel}</span>
      </div>

      <ProductVideoButton product={product} />
      <ProductFactsheetLink product={product} />
    </li>
  );
}
